export default {
  "content": "<circle cx=\"20\" cy=\"20\" r=\"20\" fill=\"#000\" fill-opacity=\".9\"/><path d=\"M21.723 18.32h-3.685l.721-3.266h3.12c1.276 0 2.014.581 2.014 1.544 0 1.14-.895 1.723-2.17 1.723zm-1.32 6.646H16.57l.845-3.826h3.122c1.544 0 2.484.648 2.484 1.812 0 1.186-.962 2.014-2.618 2.014zm7.093-8.927c0-2.128-1.62-3.509-3.845-3.908l.387-1.841a.636.636 0 00-.622-.766h-2.345c-.3 0-.56.21-.621.503l-.423 1.984h-3.851a.476.476 0 00-.465.373l-3.319 15.024c-.065.297.16.579.465.579h3.623l-.363 1.703a.636.636 0 00.617.768l2.349.018a.636.636 0 00.627-.505l.416-1.984h.366c3.76 0 6.153-2.059 6.153-4.721 0-1.566-.85-2.842-2.17-3.491 1.656-.47 3.02-1.79 3.02-3.736z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};